<template>
  <div class="ws-search-experts">
    <b-field class="ws-field"
             :label="$t('Поиск')">
      <b-autocomplete
        v-if="!multiple"
        :data="users.list"
        :loading="isUserFindPending"
        v-model="user"
        class="ws-field__control ws-field__control--taginput"
        :placeholder="placeholder"
        :allow-duplicates="false"
        autocomplete
        type="is-info"
        @typing="getUsersList"
        @select="inputUser">
        <template slot-scope="props">
          <div class="media">
            <div class="media-left">
              <figure class="image is-48x48" v-if="props.option.user_info">
                <ws-avatar :id="props.option.user_info.guid"
                           :name="`${ props.option.user_info.first.display } ${props.option.user_info.last.display}`"
                           sizeType="Small"
                           :size="48" />
              </figure>
            </div>
            <div class="media-content">
              <span v-if="props.option.user_info">
                  <span v-if="props.option.user_info.last.display && props.option.user_info.first.display">
                      <strong>{{ props.option.user_info.last.display }} {{ props.option.user_info.first.display }} {{ props.option.user_info.middle.display }}</strong> <br>
                      <span class="is-size-5">{{ props.option.region.title.display }}</span><br>
                      <span class="has-text-primary">{{ props.option.user_info.email }}</span>
                  </span>
              </span>
              <span v-else>
                  <strong>{{ props.option.email }}</strong>
              </span>
            </div>
          </div>
        </template>
        <template slot="empty">{{$t('Пользователь не найден')}}</template>
      </b-autocomplete>
      <b-taginput
        v-if="multiple"
        :data="users.list"
        :loading="isUserFindPending"
        v-model="users.value"
        class="ws-field__control ws-field__control--taginput"
        :placeholder="placeholder"
        :allow-duplicates="false"
        autocomplete
        field="fullName"
        type="is-info"
        @typing="getUsersList">
        <template slot-scope="props">
          <div class="media">
            <div class="media-left">
              <figure class="image is-48x48">
                <ws-avatar v-if="props.option.user_info" :id="props.option.user_info.guid"
                           :name="`${ props.option.user_info.first.display } ${props.option.user_info.last.display}`"
                            sizeType="Small"
                           :size="48" />
              </figure>
            </div>
            <div class="media-content">
              <span v-if="props.option.user_info">
                  <span v-if="props.option.user_info.last.display && props.option.user_info.first.display">
                      <strong>{{ props.option.user_info.last.display }} {{ props.option.user_info.first.display }} {{ props.option.user_info.middle.display }}</strong> <br>
                      <span class="is-size-5">{{ props.option.region.title.display }}</span><br>
                      <span class="has-text-primary">{{ props.option.user_info.email }}</span>
                  </span>
              </span>
              <span v-else>
                  <strong>{{ props.option.email }}</strong>
              </span>
            </div>
          </div>
        </template>
        <template slot="empty">{{$t('Пользователь не найден')}}</template>
      </b-taginput>
    </b-field>
    <button type="button" class="ws-button button is-fullwidth"
            :disabled="users.value.length === 0"
            @click="inputUsers"
            v-if="multiple"
            v-text="$t('Добавить')">
    </button>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { debounce } from 'debounce'
export default {
  name: 'WsDemoExamsSearchExperts',
  props: {
    placeholder: {
      type: String
    },
    competency_guid: {
      type: String
    },
    multiple: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      users: {
        list: [],
        value: []
      },
      user: null
    }
  },
  computed: {
    ...mapState('refbook/experts', {
      isUserFindPending: 'isFindPending'
    })
  },
  methods: {
    ...mapActions('refbook/experts', {
      findUsers: 'find'
    }),
    inputUsers () {
      this.$emit('input-users', this.users.value)
      this.users.value = []
    },
    inputUser (user) {
      this.$emit('input-user', user)
    },
    getUsersList: debounce(async function (text) {
      const keyword = text
      if (keyword) {
        let users = await this.findUsers({
          query: {
            k: keyword,
            competency_guid: this.competency_guid,
            per_page: 30
          }
        })
        users = users && users.map(user => {
          return Object.assign(user, {
            fullName: `${user.user_info.first.display} ${user.user_info.last.display}  ${user.user_info.middle.display}`
          })
        })
        this.users.list = users && users.length ? users.filter(u => !this.selected.find(s => s.guid === u.guid)) : []
      }
    }, 500)
  }
}
</script>
